import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { Empty_General_Group_Interface, General_Group_Interface } from 'src/app/Interface/General_Group_Interface';
import { AlertifyService } from 'src/app/Service/Alertify.service';
import { NavService } from 'src/app/Service/Nav/Nav.service';
import { DocumentTitleService } from 'src/app/Service/DocumentTitle/DocumentTitle.service';
import { DocumentGroupService } from 'src/app/Service/DocumentGroup/DocumentGroup.service';
import { General_Interface } from 'src/app/Interface/General_Interface';

@Component({
  selector: 'app-DocumentTitleAdd',
  templateUrl: './DocumentTitleAdd.component.html',
  styleUrls: ['./DocumentTitleAdd.component.scss']
})
export class DocumentTitleAddComponent implements OnInit {

  Token:String=""

  constructor(
    private DocumentTitle_Service:DocumentTitleService,
    private Nav_Service:NavService,
    private DocumentGroup_Service:DocumentGroupService,
    private Alertify_Service:AlertifyService
  ) { }

  ngOnInit() {
    this.Token=localStorage.getItem('Daro_User_Token');

    this.AddNewDocumentTitle=new FormGroup({
      id :new FormControl(),
      Title:new FormControl(null,Validators.required),
      GroupId:new FormControl("0",Validators.required),
    })


    this.Nav_Service.CheckValidPage(this.Token,27).subscribe(
      data=>{
        this.ReadData_DocumentGroup()
      }
      ,error=>{
        localStorage.clear()
        location.reload();
      }
    )


  }

  DataList_DocumentGroup:Array<General_Interface>=[]
  ReadData_DocumentGroup(){
    this.DocumentGroup_Service.GetActiveList(this.Token).subscribe(
      data=>{
        this.DataList_DocumentGroup=data
      },error=>{
        localStorage.clear()
        location.reload();

      }
    )
  }

  //#region  Form Add

  AddNewDocumentTitle:FormGroup;

  get_Form_Title(){
    return this.AddNewDocumentTitle.get('Title') as FormControl;
  }
  get_Form_GroupId(){
    return this.AddNewDocumentTitle.get('GroupId') as FormControl;
  }

  //#endregion

  InProccessing:boolean=false

  SubmitAddNewDocumentTitle(){

    if(this.get_Form_GroupId().value=="0")
    {
      this.Alertify_Service.ErrorMessage("Please select a document group")
    }
    else{
      var Record:General_Group_Interface =Empty_General_Group_Interface()
      Record.id=0
      Record.title=this.get_Form_Title().value
      Record.group_id=Number(this.get_Form_GroupId().value)

      console.log(Record);


      this.InProccessing=true
      this.DocumentTitle_Service.AddDocumentTitle(Record,this.Token).subscribe(
        data=>{
          this.InProccessing=false
          if(data.id==-2){
            this.Alertify_Service.ErrorMessage("The entered title already exists in the list")
          }
          else{
            this.AddNewDocumentTitle.reset()
            this.get_Form_GroupId().setValue("0")
            this.Alertify_Service.SuccessMessage("The information was registered successfully")
          }
        },error=>{
          localStorage.clear()
          location.reload();

        }
      )
    }
  }



}
